import { useEffect, useRef } from 'react';

const EVENTS = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'wheel'];
const KEY = 'tcx.lastActive'; // shared by the person's tabs, so working in one tab keeps the others signed in

/** Signs the person out after `minutes` without using the dashboard (Settings › Security › Session Timeout). */
export default function useIdleSignOut(minutes, onIdle) {
  const fired = useRef(false);
  useEffect(() => {
    if (!minutes) return undefined;
    const limit = minutes * 60 * 1000;
    let last = 0;
    const mark = () => {
      const now = Date.now();
      if (now - last < 5000) return; // at most every 5 s
      last = now;
      try { localStorage.setItem(KEY, String(now)); } catch { /* this tab still counts */ }
    };
    mark();
    EVENTS.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const timer = setInterval(() => {
      let shared = last;
      try { shared = Math.max(last, Number(localStorage.getItem(KEY)) || 0); } catch { /* use this tab's */ }
      if (Date.now() - shared > limit && !fired.current) {
        fired.current = true;
        onIdle();
      }
    }, 30000);
    return () => { EVENTS.forEach((e) => window.removeEventListener(e, mark)); clearInterval(timer); };
  }, [minutes, onIdle]);
}
